// import React, { useEffect, useState } from 'react'
import { IoCloseSharp } from "react-icons/io5";
// import { stageAPI } from '../../Utils/APIs/stageAPI';
import DatePicker from "react-datepicker"; // for range date
const Index = ({toggleState, setSelectedStage, trackingId, setTrackingId, contactNo, setContactNo, SaralId, setSaralId, searchBtn, setSearchBtn, startDate, 
  setStartDate, endDate, setEndDate, showFields = [ true, true, true, true, true, true ] // Control which fields to display
}) => {
  // const [stageList, setStageList] = useState([]);
  // const [dropdownToggle, setDropdownToggle] = useState(false);
  // useEffect(()=>{
  //   stageAPI(setStageList);
  // },[])
  // const handleSelection = (value) => {
  //   setSelectedStage((prev) =>
  //     prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
  //   );
  // };
  return (
    <>
      <div className='fixed bottom-0 right-0 flex z-40  overflow-y-auto transition-transform w-full h-[calc(100%-4.2rem)] scroll-py-16' >
        <div className='text-white w-full bg-dark opacity-2'></div>
        <div className='bg-white w-96 float-right h-auto'>
          <button className='bg-yellow-300 relative -left-8 p-2 shadow-lg' onClick={()=>toggleState(false)}><IoCloseSharp /></button>
          <div className="grid gap-3 m-6 md:grid-cols-1 bg-white">
            
          {showFields[0] && (
            <div>
                <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Saral ID</label>
                <input value={SaralId} onChange={(e)=>setSaralId(e.target.value)} type="text" id="first_name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5" placeholder="Saral Id"/>
            </div>
          )}

           { showFields[1] && (
            <div>
                <label for="contact" className="block mb-2 text-sm font-medium text-gray-900 ">Contact No.</label>
                <input value={contactNo} onChange={(e)=> setContactNo(e.target.value)} type="number" id="contact"   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5" placeholder="Contact No." required />
            </div>
           )}

           { showFields[2] && (
            <div>
                <label for="tracking" className="block mb-2 text-sm font-medium text-gray-900 ">Tracking Id.</label>
                <input value={trackingId} onChange={(e)=>setTrackingId(e.target.value)} type="text" id="tracking"   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5" placeholder="Tracking id" required />
            </div>
           )}

            

            {/* for date picker */}
            { showFields[4] && <div>
              <label htmlFor="date-range" className="block mb-2 text-sm font-medium text-gray-900 ">Select Date Range</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start Date"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block p-2.5 pr-24"
              />
            </div>}
            
            { showFields[5] && <div>
                <span className=" block pb-2 text-sm font-medium text-gray-900 ">to</span>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate} // Prevent selecting end date before the start date
                  placeholderText="End Date"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block p-2.5 pr-24"
                />
            </div>}
            
            <div className='flex flex-row justify-evenly bg-white w-full'>
              <button 
                className='text-dark bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center'
                onClick={()=>{
                  console.log("filterClick")
                  toggleState(false); 
                  setSearchBtn(!searchBtn)
                }}
              >Filter</button>
              <button 
                className=' text-dark bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center'
                onClick={()=>{
                  setSelectedStage([]);
                  setTrackingId("");
                  setSaralId("");
                  setContactNo("");
                  setStartDate("");
                  setEndDate("");
                  setSearchBtn(!searchBtn);
                }}
              >Reset</button>
            </div>
            <div>    
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Index
// {(showFields[3] && selectedStage !== null)  && <div>
//                 <label for="stage" className="block mb-2 text-sm font-medium text-gray-900 ">Stage</label>
//                 <div className="relative">
//                 {/* Toggle Button */}
//                 <button
//                   type="button"
//                   className="relative py-3 ps-4 pe-9 flex gap-x-2 w-full bg-gray-50 border border-gray-200 rounded-sm text-start text-sm"
//                   onClick={()=>setDropdownToggle(!dropdownToggle)}
//                 >
//                 {selectedStage.length > 0
//                   ? `${selectedStage.length} selected`
//                   : "Select multiple options..."}
//                 <div className="absolute top-1/2 end-3 -translate-y-1/2">
//                   <svg
//                     className="shrink-0 size-3.5 text-gray-500"
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <path d="m7 15 5 5 5-5" />
//                     <path d="m7 9 5-5 5 5" />
//                   </svg>
//                   </div>
//                 </button>

//                 {/* Dropdown */}
//                 {  dropdownToggle &&
//                   <div className="mt-2 z-50 w-full max-h-48 p-1 space-y-0.5 bg-white border border-gray-200 rounded-sm overflow-hidden overflow-y-auto">
//                   {stageList.map(({_id,stage}) => (
//                     <div
//                       key={_id}
//                       className={`flex items-center py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg ${
//                         selectedStage.includes(_id) ? "font-semibold" : ""
//                       }`}
//                       onClick={() => handleSelection(_id)}
//                     >
//                       <div>{stage}</div>
//                       <div className="ms-auto">
//                         {selectedStage.includes(_id) && (
//                           <span>
//                             <svg
//                               className="shrink-0 size-4 text-blue-600"
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="16"
//                               height="16"
//                               fill="currentColor"
//                               viewBox="0 0 16 16"
//                             >
//                               <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
//                             </svg>
//                           </span>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//                 }
//               </div>
//             </div>}